import { CountryIso3166 } from "@tfg/db"
import { FlagComponent } from "country-flag-icons/react/1x1"
import * as flags from "country-flag-icons/react/3x2"
import { ReactElement } from "react"

interface Props {
  countryIso3166: CountryIso3166
  width?: number
}
export const CountryFlag = ({
  countryIso3166,
  width,
}: Props): ReactElement<FlagComponent> | null => {
  let Flag: flags.FlagComponent | null = null
  if (
    countryIso3166 != "CP" &&
    countryIso3166 != "UN" &&
    countryIso3166 != "DG" &&
    countryIso3166 != "EA"
  ) {
    Flag = flags[countryIso3166] as FlagComponent
  }

  return Flag ? <Flag width={width ? width : 18} /> : null
}
